import React from 'react';
import { Route, Switch } from 'react-router';
import Introduction from './Introduction';
import Normal from './Normal';
import Helpdesk from './Helpdesk'
import Feedback from './Helpdesk/Feedback'

class FAQ extends React.Component {
    render() {
        return (
            <Switch>
                <Route path='/clientChat/faq/introduction' component={Introduction}/>
                <Route path='/clientChat/faq/helpdesk' component={Helpdesk}/>
                <Route path='/clientChat/faq/helpdesk/feedback' component={Feedback}/>
                <Route path='/clientChat/faq' component={Normal}/>
            </Switch>
        )
    }
}

export default FAQ



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/index.js